import classnames from 'classnames'
import * as d3 from 'd3'
import { CSSProperties, Component, MouseEvent } from 'react'

import { GradientDefinition } from '../../shared/gradients'
import { futuresDomains } from '../utils'
import { generateColorScale as gcs } from '../utils'

var generateColorScale = gcs.bind(null, futuresDomains)

interface Bar {
  label: string
  value: number
  isInactive?: boolean
}

interface BarChartProps {
  width: number
  barHeight?: number
  period: string
  //height: number,
  //title: string,
  //date: string, // TODO
  data: Bar[]
  onClick?: (bar: Bar) => void
  gap: number
  gradient?: GradientDefinition
  alignHeaderToBars?: boolean
  isHorizontal?: boolean
  isWrapper?: boolean
}

class BarChart extends Component<BarChartProps> {
  state = { hoveredGroup: null }

  static defaultProps = {
    gap: 0.5,
  }

  render() {
    var rows = this.props.data
    var labels = rows.map(function (d) {
      return d.label
    })

    var width = this.props.width,
      barHeight = this.props.barHeight || 12,
      height = (barHeight + this.props.gap * 2) * rows.length,
      leftWidth = 100

    var x = d3
      .scaleLinear()
      .domain([0, d3.max(rows, (d: Bar) => Math.abs(d.value))!])
      .range([0, width - leftWidth - 40])
      .nice(6)

    var xAxisTicks = x.ticks(6)

    var y = d3
      .scaleBand()
      .domain(labels)
      .range([0, (barHeight + 2 * this.props.gap) * labels.length])

    var colorScale = generateColorScale(this.props.period, this.props.gradient)

    // so React won't reorder our elements
    rows = rows.slice().sort(function (a, b) {
      if (a.label < b.label) {
        return -1
      }
      if (a.label > b.label) {
        return 1
      }
      return 0
    })

    var header =
      // @ts-ignore
      {
        d: '1 Day',
        w: '1 Week',
        m: '1 Month',
        mtd: 'Month to date',
        q: '3 Month',
        hy: 'Half year',
        y: '1 Year',
        ytd: 'Year to Date',
      }[this.props.period] + ' Performance'

    return (
      <div
        className={classnames({
          'fv-bar-chart': FinvizSettings.hasRedesignEnabled,
          'bar-chart': !FinvizSettings.hasRedesignEnabled,
          'is-horizontal': this.props.isHorizontal,
          'is-wrapper': this.props.isWrapper,
        })}
        style={{ width }}
      >
        <h1
          {...(this.props.alignHeaderToBars && {
            style: {
              marginLeft: leftWidth,
            },
          })}
        >
          {header}
        </h1>
        <div style={{ position: 'relative', height: height - 1 }}>
          {xAxisTicks.map((tick: any) => (
            <div
              className="bar-chart_tick"
              style={{ position: 'absolute', top: 1, left: leftWidth + Math.round(x(tick)) }}
              key={tick}
            >
              <div>{tick}%</div>
            </div>
          ))}
          <div
            className="bar-chart_top"
            style={{ left: leftWidth, width: Math.round(x(xAxisTicks[xAxisTicks.length - 1])) }}
          ></div>
          <div
            className="bar-chart_bottom"
            style={{ left: leftWidth, width: Math.round(x(xAxisTicks[xAxisTicks.length - 1])) }}
          ></div>
          {rows.map((row) => {
            var large = x(Math.abs(row.value)) > 40
            var width = Math.round(x(Math.abs(row.value)))
            var style: CSSProperties = {
              position: 'absolute',
              top: y(row.label)! + this.props.gap,
              left: leftWidth,
              width: width,
              height: barHeight,
              ...(!row.isInactive && { background: colorScale(row.value) }),
            }
            return (
              <div
                key={row.label}
                style={style}
                className={'rect ' + (row.isInactive ? 'is-inactive' : '')}
                onClick={this._onClick.bind(this, row)}
              >
                <div
                  className={'value' + (large ? '' : ' is-outside')}
                  style={{ left: large ? 0 : width + 4, color: large ? '#fff' : colorScale(row.value) }}
                >
                  {row.value > 0 ? '+' : ''}
                  {row.value}
                </div>
                <div className="label">{row.label}</div>
              </div>
            )
          })}
        </div>
        <br />
        <br />
      </div>
    )
  }

  _onClick = (row: Bar, e: MouseEvent) => {
    e.preventDefault()
    this.props.onClick?.(row)
  }
}

export default BarChart
